module.exports = __webpack_public_path__ + "static/img/企业文化3.806e4f0b.png";